// ** Modules
import { useQuery } from '@apollo/client/react';
import { gql, type TypedDocumentNode } from '@apollo/client';

// ** Utils
import { RecursivePageLink } from './fragments';

// ** Types
import type { Query } from '@/types/graphql';

// ** Queries Schemas
export const getNavigation: TypedDocumentNode<Pick<Query, 'navigation'>, { locale?: string | null }> = gql`
    ${RecursivePageLink}

    query Navigation($locale: I18NLocaleCode) {
        navigation(locale: $locale) {
            navItems {
                ... on ComponentNavigationMenuItem {
                    __typename
                    title
                    url
                    icon {
                        icon
                    }
                    authenticated
                    active
                    onlyVisibleToGroups
                    ssoGroups
                    children {
                        __typename
                        title
                        url
                        active
                        onlyVisibleToGroups
                        ssoGroups
                        pageLink {
                            ...RecursivePageLink
                        }
                        children {
                            __typename
                            title
                            url
                            active
                            onlyVisibleToGroups
                            ssoGroups
                            pageLink {
                                ...RecursivePageLink
                            }
                        }
                        pageLink {
                            ...RecursivePageLink
                        }
                    }
                    pageLink {
                        ...RecursivePageLink
                    }
                }
                ... on ComponentNavigationMenuDivider {
                    __typename
                    sectionTitle
                    authenticated
                    active
                }
                ... on Error {
                    code
                    message
                }
            }
        }
    }
`;

//////////////////
// ** Query Functions

// Get Navigation
export const useGetNavigation = (locale: string, forceRefetch: boolean) => {
	const props = useQuery(getNavigation, {
		variables: { locale },
		skip: !locale,
		fetchPolicy: forceRefetch ? 'no-cache' : 'cache-first'
	});

	const data = props.data ?? { navigation: null };

	return { ...props, data };
};
